import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { BaseDashboardFiltersComponent } from '../base-dashboard-filters.component';
import { GaValidateService } from '../../../../../shared/formly/ga-validate.service';
import { GaMessageService } from '../../../../../shared/message/ga-message.service';
import { TranslationService } from '../../../../../shared/translation/translation.service';
import { ReportDataService } from '../../../../../shared/report/report-data.service';
import { ReportFiltersUtil } from '../../../../../shared/report/report-filters-util.service';
import { DashboardService } from '../../dashboard.service';
import { GaDeferredService } from '../../../../../shared/services/ga-deferred.service';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { Override } from '../../../../../shared/app-decorators';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../../shared/services/formatting.service';
import { CompanyDataService } from '../../../../../shared/company/company-data.service';
import { WebshopDataService } from '../../../../webshop/webshop-data.service';
import { CountryDataService } from '../../../../../shared/location/country-data.service';
import { DashboardDataService } from '../../../../../shared/report/dashboard-data.service';

@Component({
  selector: 'bp-setup-dashboard-filters',
  templateUrl: '../base-dashboard-filters.component.html'
})
export class BpSetupDashboardFiltersComponent extends BaseDashboardFiltersComponent implements OnDestroy {
  private customerField:IExtraFieldConfigurationObject;
  private geographyField:IExtraFieldConfigurationObject;
  private countryField:IExtraFieldConfigurationObject;
  private armField:IExtraFieldConfigurationObject;
  private bpRequestedByCompanyTypeField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    private companyDataService:CompanyDataService,
    private webshopDataService:WebshopDataService,
    private countryDataService:CountryDataService,
    private dashboardDataService:DashboardDataService,
    validateService:GaValidateService,
    messageService:GaMessageService,
    translationService:TranslationService,
    reportDataService:ReportDataService,
    reportFiltersUtil:ReportFiltersUtil,
    dashboardService:DashboardService,
    deferredService:GaDeferredService,
    authService:AuthService,
    cdr:ChangeDetectorRef
  ) {
    super(validateService, messageService, translationService, reportDataService, reportFiltersUtil, dashboardService, deferredService, authService, cdr);
  }

  protected customValidatorFn = ():Promise<void | string[]> => {
    if (!this.model.customer && !this.model.geography && !this.model.bpRequestedByCompanyType
      && !this.model.country && !this.model.arm && !this.model.bpRequestedBy) {
      return Promise.reject('Please select at least one of the following filters: Webshop, Geography, Country, ARM, BP Requested by company type, BP Requested by');
    }

    return Promise.resolve();
  };

  @Override(BaseDashboardFiltersComponent)
  public fillFields():void {
    Promise.all([
      this.formlyService.fillField(this.customerField, this.webshopDataService.webshops()),
      this.formlyService.fillField(this.countryField, this.countryDataService.getAllCountries()),
      this.formlyService.fillField(this.geographyField, this.countryDataService.listContinents()),
      this.formlyService.fillField(this.bpRequestedByCompanyTypeField, this.companyDataService.getCompanyTypes()),
      this.formlyService.fillField(this.armField, this.dashboardDataService.gbdms())
    ]).then(this.setQueryFilters);
  }

  @Override(BaseDashboardFiltersComponent)
  public createFields():IExtraFieldConfigurationObject[] {
    return [
      this.customerField = this.formlyService.aSearch('customer', 'Webshop')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatName)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.geographyField = this.formlyService.aSearch('geography', 'Geography')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatName)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.countryField = this.formlyService.aSelect('country', 'Country')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatCountry)
        .build(),

      this.armField = this.formlyService.aSelect('arm', 'ARM')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatContact)
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),

      this.bpRequestedByCompanyTypeField = this.formlyService
        .aSelect('bpRequestedByCompanyType', 'BP Requested by company type')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatLov)
        .build(),

      this.formlyService.aSearch('bpRequestedBy', 'BP Requested by')
        .withWrapperClass(this.wrapperClass)
        .withFormat(this.formattingService.formatCompany)
        .withExtraOptions({
          templateOptions: {
            searchFunction: {
              request: (filter:string) => this.companyDataService.searchCompanies(filter, null)
            }
          }
        })
        .build()
    ];
  }

  public ngOnDestroy():void {
    this.dashboardDataService.clear();
  }
}